import useSWR from 'swr'

import { knowledgeApi } from '@/lib/api'

import { SocialCitationPost } from '@digital-twins/shared-types'

/** Hosts a stored social post can live on; any other link is never looked up. */
const SOCIAL_HOSTS = /(^|\.)(youtube\.com|youtu\.be|tiktok\.com|instagram\.com|reddit\.com)$/

const MAX_LOOKUPS = 50

function isSocialPostUrl(url: string): boolean {
  try {
    return SOCIAL_HOSTS.test(new URL(url).hostname)
  } catch {
    return false
  }
}

/**
 * The org's stored social posts behind an answer's post links, keyed by
 * link. One lookup per settled answer; nothing is fetched while it streams
 * or when it links no social post.
 */
export function useLinkedSocialPosts(urls: Array<string>, isEnabled: boolean): Map<string, SocialCitationPost> {
  const candidates = Array.from(new Set(urls.filter(isSocialPostUrl))).sort().slice(0, MAX_LOOKUPS)
  const key = isEnabled && candidates.length > 0 ? ['thread-linked-social-posts', ...candidates] : null

  const { data } = useSWR(key, () => knowledgeApi.resolveSocialPostsByUrl(candidates), {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  })

  return new Map((data?.posts ?? []).map((post) => [post.url, post]))
}
